import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { SEMANAS } from '../../constants/semanas';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ISelectSettings } from '../select/models/select-settings.interface';
import { ISelectOption } from '../select/models/select-option.interface';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { SelectComponent } from '../select/select.component';

@Component({
  selector: 'sgt-semana-select',
  templateUrl: './semana-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SemanaSelectComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SemanaSelectComponent
  extends CustomControlValueAccessor<number>
  implements OnInit, OnChanges {
  @Input() semana: number | null = null;
  @Output() changed = new EventEmitter<number | null>();

  @ViewChild(SelectComponent) selectComponent: SelectComponent;

  settingsSelectSemana: ISelectSettings = {
    placeholder: 'Selecione uma semana',
    isDisabled: false,
    required: false,
    isClearSelectionAllowed: false,
  };

  semanasSelectOptions: ISelectOption[] = [];

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.buildSelectOptions();

    const semana = this.semana;
    this.updateComponent(semana);
  }

  buildSelectOptions() {
    this.semanasSelectOptions.push({
      id: null,
      label: 'Nenhuma Semana',
    });

    SEMANAS.forEach((semana) => {
      this.semanasSelectOptions.push({
        id: semana.id,
        label: semana.nome,
      });
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['semana']) {
      this.updateValue(this.semana);
    }
  }

  onChangeSemana(semana: ISelectOption): void {
    this.semanasSelectOptions.forEach((s: ISelectOption) => {
      s.isSelected = s.id === semana.id;
    });

    this.emitChange(semana.id);
    this.markAsTouched();

    this.changed.emit(semana.id);
  }

  updateComponent(value: number): void {
    this.updateValue(value);
  }

  // Implementação do método abstrato da classe base
  protected updateValue(value: number | null): void {
    const selectedId = value;

    this.semanasSelectOptions.forEach((semana) => {
      semana.isSelected = semana.id === selectedId;
    });

    if (this.selectComponent) {
      const selectedOption = this.semanasSelectOptions.find(
        (s) => s.id === selectedId
      );
      this.selectComponent.writeValue(selectedOption?.id ?? null);
    }
  }

  // Override do onDisabledStateChange para atualizar as configurações
  protected onDisabledStateChange(isDisabled: boolean): void {
    this.settingsSelectSemana = {
      ...this.settingsSelectSemana,
      isDisabled,
    };
  }
}
